export default __webpack_public_path__ + "4dca33fef4dd7775de8cee0dbd75121d.svg";